import React, { useEffect, useState } from 'react';
import { SelectNormalS } from '../Reusable/SelectBox'; 
import { Input, Row, Col, Card } from 'antd';
import CustomTextField from '../Reusable/Numerictext';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../App';
import Loader from '../Reusable/RLoader';
import { Backdrop, CircularProgress, Box, Button } from '@mui/material';

const Test = () => {
    const [selectedItem, setSelectedItem] = useState(null);
    const [serialNo, setSerialNo] = useState('');
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [dealerDetails, setDealerDetails] = useState([]);
    const [customerDetails, setCustomerDetails] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [open, setOpen] = useState(false);

    const handleInputChange = (event) => {
        const inputValue = event.target.value;
        if (/^[a-zA-Z0-9]*$/.test(inputValue)) {
            setSerialNo(inputValue);
        }
    };

    const handleItemChange = (event) => {
        const value = event.target.value;
        const selectedOption = options.find(option => option.label === value);
        setSelectedItem(selectedOption);
    };

    const handleClick = async () => {
        setOptions([]);
        setSelectedItem(null);
        setDealerDetails([]);
        setCustomerDetails([]);
        setShowTable(false);
        setErrorMessage('');
        setOpen(true);
        try {
            const response = await axios.post(BASE_URL + '/itemcode', {
                serial_no: serialNo
            });
            setOpen(false);

            const responseData = response.data;
            if (responseData.status_code === 200) {
                if (responseData.data.length === 0) {
                    Swal.fire({
                        icon: 'info',
                        title: 'No Data Found',
                        text: 'No items found for the provided serial number.'
                    });
                    return;
                }
                const options = responseData.data.map(item => ({
                    value: item.MAT_CODE.trim(),
                    label: `${item.MAT_CODE.trim()} - ${item.DESCRIPTION.trim()}`
                }));
                setOptions(options);

                if (options.length === 1) {
                    setSelectedItem(options[0]);
                }
            } else {
                setErrorMessage('Failed to fetch data. Please try again.');
            }
        } catch (error) {
            console.error(error);
            setErrorMessage('Error fetching data. Please try again.');
        } finally {
            setOpen(false);
        }
    };

    const handleViewClick = async () => {
        setOpen(true);
        try {
            const response = await axios.post(
                BASE_URL + '/dealerdetails',
                {
                    serial_no: serialNo,
                    item_code: selectedItem.value
                }
            );
            const responseData = response.data;
            setDealerDetails(responseData.data);

            const customerresponse = await axios.post(
                BASE_URL + '/customerdetails',
                {
                    serial_no: serialNo,
                    item_code: selectedItem.value
                }
            );
            const responseCustomerData = customerresponse.data;
            setCustomerDetails(responseCustomerData.data);
            setShowTable(true);
        } catch (error) {
            Swal.fire({
                icon: "warning",
                text: 'Please Enter the Required Details.'
            });
        } finally {
            setOpen(false);
        }
    };

    useEffect(() => {
        setErrorMessage('');
    }, [serialNo]);

    return (
        <div className='container'>

            <br></br>
            <Card className="shadow bg-white rounded">

                <Box
                    component="form"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        '& > :not(style)': { marginRight: '10px' },
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <CustomTextField
                        name="Serial"
                        label="Enter Serial No"
                        value={serialNo}
                        onChange={handleInputChange}
                        style={{ width: '50%' }}
                    />

                    <Button disabled={!serialNo.trim()}
                        onClick={handleClick}
                        style={{ background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)', color: 'black' }} variant="contained">View Materials</Button>
                </Box></Card>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <br></br>
<Row><Col span={12} style={{marginRight: '10px'}}>
            {options.length > 0 && (

                <SelectNormalS
                    options={options.map(option => option.label)}
                    value={selectedItem ? selectedItem.label : ''}
                    onChange={handleItemChange}
                    required
                    size="normal"
                    name="code"
                />
            )}
        </Col><Col span={10}>
            {selectedItem && (
                    <Button

                        onClick={handleViewClick}
                        style={{ background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)', color: 'black', width: '35%',marginTop:'20px' }} variant="contained"
                    >
                        View Details
                    </Button>

            )}
            </Col></Row>
            <br /><br />

            {errorMessage && <p>{errorMessage}</p>}

            {showTable && (
                <>
                    <h5 style={{ fontWeight: 'bold', textDecoration: 'underline', textAlign: 'center' }}>Serial Number Transaction Details</h5>
                    <div style={{ overflowX: 'hidden' }}>
                        <table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
                            <thead>
                                <tr>
                                    <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Branch Code</th>
                                    <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Branch Name</th>
                                    <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Document</th>
                                    <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Document No</th>
                                    <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Doc Date</th>
                                    <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Party Code</th>
                                    <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Party Name</th>
                                    <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Warranty Status</th>
                                    <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Created On</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dealerDetails.map((detail, index) => (
                                    <tr key={index} style={{ background: '#e3fafe' }}>
                                        <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                            {detail.BRANCH_CODE}
                                        </td>

                                        <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                            {detail.BRANCH_NAME}
                                        </td>


                                        <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                            {detail.DOCUMENT.includes("INV") ? (
                                                <button className="btn btn-danger" style={{ width: '80%', borderRadius: '3px' }}>{detail.DOCUMENT}</button>
                                            ) : (
                                                <button className="btn btn-success" style={{ width: '80%', borderRadius: '3px' }}>{detail.DOCUMENT}</button>
                                            )}
                                        </td>
                                        <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out', color: '#00008b' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                            {detail.DOC_NO}
                                        </td>
                                        <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                            {detail.DOC_DATE}
                                        </td>
                                        <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                            {detail.PARTYCODE}
                                        </td>
                                        <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out', color: '#00008b' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                            {detail.PARTYNAME}
                                        </td>
                                        <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                            {detail.WARRANTYSTATUS}
                                        </td>

                                        <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>

                                            {new Date(detail.CREATEDON).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric'
                                            }).replace(/ /g, '-')}

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <h5 style={{ fontWeight: 'bold', textDecoration: 'underline', textAlign: 'center' }}>Customer Details</h5>
                    <div style={{ overflowX: 'hidden' }}>
                        {customerDetails.length > 0 ? (
                            <table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
                                <thead>
                                    <tr>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Customer Name</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Address</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Place</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Country</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Region</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>District</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>City</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Area</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Pin Code</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Mobile No</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Invoice Date</th>
                                        <th style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Warranty Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {customerDetails.map((customer, index) => (
                                        <tr key={index} style={{ background: '#e3fafe' }}>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.CUSTOMER_NAME}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.ADDRESS}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.PLACE}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.COUNTRY}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.REGION}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.DISTRICT}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.CITY}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.AREA_NAME}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.PINCODE}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.MOBILE_NO}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.INVOICE_DATE}
                                            </td>
                                            <td style={{ padding: '10px', transition: 'transform 0.2s ease-in-out' }}
                                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                                {customer.WARRANTY_STATUS}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p style={{ textAlign: 'center', fontSize: '16px', color: '#ff4d4d', fontWeight: 'bold' }}>
                                Customer Registration Not Yet Done
                            </p>
                        )}
                        <br />
                    </div>

                </>
            )}
        </div>
    );
};

export default Test;
